import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import HeaderEntreprise from '../../header/headerEntreprise';
import MissionTabs from '../../commun/MissionTabs';
import MissionInfo from '../../commun/MissionInfo';
import ProfilRecherche from '../../commun/ProfilRecherche';
import InfosComplementaires from '../../commun/InfosComplementaires';
import ContactCard from '../../commun/ContactCard';
import InfoCard from '../../commun/InfoCard';
import CustomAlert from '../../commun/CustomAlert';
import HistoriqueTab from '../../Recruteur/candidat/detailTalent/HistoriqueTab'; 
import './Detailsmission.css';
import Chatbox from '../../commun/ChatBox';
import Footer from '../../commun/Footer';
import LoadingPopup from '../../commun/LoadingPopup';
import ActionCandidater from '../../commun/ActionCandidater';
import NotFound404 from '../../commun/NotFound404';

const Detailsmission = () => {
  const entrepriseName = localStorage.getItem("entrepriseName");
  const { id } = useParams();
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const [mission, setMission] = useState(null);
  const [editedMission, setEditedMission] = useState({});
  const [activeTab, setActiveTab] = useState('mission');
  const [isEditing, setIsEditing] = useState(false);
  const [candidatures, setCandidatures] = useState([]);
  const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });
  const [entreprise, setEntreprise] = useState(null);
  const [usersList, setUsersList] = useState([]);
  const [notFound, setNotFound] = useState(false);

  const showAlert = (message, severity = 'success') => {
    setAlert({ open: true, message, severity });
  };

  const handleCloseAlert = () => {
    setAlert({ ...alert, open: false });
  };

  useEffect(() => {
    const fetchMission = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/missions/${id}`);
        if (!res.ok) {
          setNotFound(true);
          return;
        }   
        const data = await res.json();
        setMission(data);
        setEditedMission(data);
        fetchEntreprise(data.createdBy);
      } catch (err) {
        setNotFound(true);
        showAlert('Erreur lors du chargement de la mission.', 'error');
      }
    };

    const fetchEntreprise = async (userId) => {
  try {
    const res = await fetch(`${API_BASE}/api/entreprise/profil/${userId}`);
    const data = await res.json();
    setEntreprise(data);

    const users = [
      {
        id: data.utilisateur?._id,
        nom: `${data.utilisateur?.firstName || ''} ${data.utilisateur?.lastName || ''}`.trim(),
        email: data.utilisateur?.email,
        telephone: data.utilisateur?.phone,
      },
      ...(data.utilisateursAdditionnels || []).map(u => ({
        id: u._id,
        nom: `${u.firstName || ''} ${u.lastName || ''}`.trim(),
        email: u.email,
        telephone: u.phone,
      }))
    ].filter(u => u.email);

    setUsersList(users);
  } catch (err) {
    showAlert('Erreur lors du chargement de l’entreprise.', 'error');
    setNotFound(true);
  }
};


    const fetchCandidatures = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/candidatures/mission/${id}`);
        if (!res.ok) {
          setNotFound(true);
          return;
        }   
        const data = await res.json();
        setCandidatures(data);
      } catch (err) {
        showAlert('Erreur lors du chargement des candidatures.', 'error');
        setNotFound(true);
      }
    };

    fetchMission();
    fetchCandidatures();
  }, [id]);

  const handleChange = (field, value) => {
    setEditedMission(prev => ({ ...prev, [field]: value }));
  };

  const validateMission = (mission) => {
  if (!mission.nomMission) return 'Le champ "Intitulé de la mission" est requis.';
  if (!mission.lieuxTravail) return 'Le champ "Lieu de travail" est requis.';
  if (!mission.modeTravail) return 'Le champ "Mode de travail" est requis.';
  if (!mission.secteur) return 'Le champ "Secteur" est requis.';
  return null; 
};

  const handleToggleStatus = async () => {
    const validationError = validateMission(editedMission);
    if (validationError) {
      showAlert(validationError, 'error');
      return; 
    }
  
    const newStatus = editedMission.status === 'active' ? 'inactive' : 'active';
    try {
      const res = await fetch(`${API_BASE}/api/missions/${editedMission._id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...editedMission, status: newStatus })
      });
  
      if (res.ok) {
        handleChange('status', newStatus);
        setMission(prev => ({ ...prev, status: newStatus }));
        showAlert(`Statut changé en ${(newStatus || 'inconnu').toUpperCase()}`, 'success');
      } else {
        showAlert('Erreur lors du changement de statut.', 'error');
      }
    } catch (err) {
      showAlert('Erreur serveur lors du changement de statut.', 'error');
      setNotFound(true);
    }
  };
  

  const handleSave = async () => {
    try {
      if (!editedMission.regionTravail && editedMission.lieuxTravail) {
        editedMission.regionTravail = editedMission.lieuxTravail;
      }
  
      if (editedMission.entreprise && typeof editedMission.entreprise === 'object') {
        editedMission.entreprise = editedMission.entreprise._id;
      }
      if (editedMission.utilisateur && typeof editedMission.utilisateur === 'object') {
        editedMission.utilisateur = editedMission.utilisateur._id;
      }
  
      // ✅ Validation des contrats
      if (editedMission.contrats && editedMission.contrats.length > 0) {
        for (const contrat of editedMission.contrats) {
          if (!contrat.type) {
            showAlert("Le type de contrat n'est pas sélectionné.", "error");
            return;
          }
          if (!contrat.tarifMax) {
            const champ = contrat.type === "CDI" ? "salaire maximum" : "TJM maximum";
            showAlert(`Le ${champ} n'est pas saisi.`, "error");
            return;
          }
          if (contrat.tarifMin && Number(contrat.tarifMin) > Number(contrat.tarifMax)) {
            showAlert("Le minimum doit être inférieur ou égal au maximum.", "error");
            return;
          }
        }
      }
  
      const token = localStorage.getItem('authToken');
  
      // 📄 Fonction de conversion en base64
      const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      };
  
      // 🧾 Création de la charge utile (payload)
      let payload = { ...editedMission };
  
      // 🟢 Cas 1 : ajout ou remplacement de fichier
      if (editedMission.document instanceof File) {
        const base64String = await fileToBase64(editedMission.document);
        payload.document = {
          name: editedMission.document.name,
          data: base64String
        };
      }
  
      // 🟥 Cas 2 : suppression du fichier
      else if (editedMission.document === null) {
        payload.document = null;
      }
  
      // ✨ Sérialisation propre des champs objets / arrays
      Object.keys(payload).forEach((key) => {
        if (Array.isArray(payload[key]) || typeof payload[key] === 'object') {
          if (key !== 'entreprise' && key !== 'utilisateur' && key !== 'document') {
            payload[key] = JSON.stringify(payload[key]);
          }
        }
      });
  
      const res = await fetch(`${API_BASE}/api/missions/${editedMission._id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload),
      });
  
      if (res.ok) {
        const updated = await res.json();
        setMission(updated.mission);
        setIsEditing(false);
        showAlert('✅ Modification réussie.', 'success');
      } else {
        showAlert('❌ Erreur lors de la mise à jour.', 'error');
      }
  
    } catch (err) {
      console.error('❌ Erreur handleSave:', err);
      showAlert('⚠️ Erreur serveur lors de la mise à jour.', 'error');
    }
  };
  
  if (notFound) return <NotFound404 />;
  if (mission === null) return <LoadingPopup open={true} message="Chargement de la mission..." />;

  return (
    <div className="entreprise-page">
      <HeaderEntreprise entrepriseName={entrepriseName} />

      <main className="pageContainer">
        <div className="contentWrapper">
          <div className="contentGrid">
        {/* ✅ Colonne gauche */}
        <aside className="leftColumn">
        <ContactCard
          mission={editedMission}
          editable={isEditing}
          onChange={handleChange}
          utilisateur={mission.utilisateur}
          users={usersList}      
        />
        
        <ActionCandidater 
        mission={mission} 
        candidatures={candidatures} 
        hideButton={true} 
        />

        </aside>

       {/* ✅ Colonne principale */}
        <section className="mainColumn">
        <div className="missionContent">
          <MissionTabs activeTab={activeTab} setActiveTab={setActiveTab} viewerType="entreprise" />
          {activeTab === 'mission' && (
            <MissionInfo
              mission={mission}
              editedMission={editedMission}
              editable={isEditing}
              onChange={handleChange}
              onSave={handleSave}
              onToggleStatus={handleToggleStatus}
              onToggleEdit={() => setIsEditing(prev => !prev)}
              showActionButtons={true}
              entrepriseLogo={entreprise?.logo}
            />
          )}
          {activeTab === 'profil' && (
            <ProfilRecherche
              editedMission={editedMission}
              editable={isEditing}
              onChange={handleChange}
              onSave={handleSave}
              onToggleEdit={() => setIsEditing(prev => !prev)}
              showActionButtons={true}
              entrepriseLogo={entreprise?.logo}
              onToggleStatus={handleToggleStatus}
            />
          )}
          {activeTab === 'infos' && (
            <InfosComplementaires candidatures={candidatures} viewerType="entreprise" />
          )}
          {activeTab === 'historique' && (
            <HistoriqueTab historique={mission.historique || []} />
          )}
        </div>
        </section>

        {/* ✅ Colonne droite */}
        <aside className="rightColumn">
          <InfoCard
            mission={editedMission}
            editable={isEditing}
            onChange={handleChange}
          />
        </aside>
        </div>

        </div>
      </main>

      <Footer />

      <CustomAlert
        open={alert.open}
        message={alert.message}
        severity={alert.severity}
        onClose={handleCloseAlert}
      />

      <Chatbox userRole="entreprise" />
    </div>
  );
};

export default Detailsmission;
